
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiClassiDialog extends Serenity.EntityDialog<ProdottiClassiRow, any> {
        protected getFormKey() { return ProdottiClassiForm.formKey; }
        protected getIdProperty() { return ProdottiClassiRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiClassiRow.localTextPrefix; }
        protected getNameProperty() { return ProdottiClassiRow.nameProperty; }
        protected getService() { return ProdottiClassiService.baseUrl; }
        protected getDeletePermission() { return ProdottiClassiRow.deletePermission; }
        protected getInsertPermission() { return ProdottiClassiRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiClassiRow.updatePermission; }

        protected form = new ProdottiClassiForm(this.idPrefix);

    }
}